import MyBread from '../../components/Breadcrumbs'

export default function Master() {
  return (
    <>
    <div>
    <MyBread />
    <div>マスターの一覧</div>
    </div>
    </>
  )
}
